import { connectedStore } from '../../store';
import selectors from '../selectors';

const getOwnerId = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getOwnerId(state);
};

export default getOwnerId;
